export default "__VITE_ASSET__DENe8GNt__"